import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../Styles/RegisterYubiKey.css";
import UserProfileHeader from './UserProfileHeader';
import Axios from 'axios';

const RegisterYubiKey = () => {
    const navigate = useNavigate();

    const initialValues = {
        serial: '',
        otp1: '',
        otp2: '',
    };

    const validationSchema = yup.object().shape({
        serial: yup.string().required("Serial number is required!"),
        otp1: yup.string()
            .required("OTP 1 is required!")
            .min(12, "This OTP is invalid!"),

        otp2: yup.string()
            .required("OTP 2 is required!")
            .min(12, "This OTP is invalid!")
            .test("otp-match", "These two OTPs are invalid, please try again!", function (value) {
                const { otp1 } = this.parent;
                return otp1 && value && otp1.slice(0, 12) === value.slice(0, 12);
            }),
    });

    const handleSubmit = (values, { resetForm }) => {
        Axios.post(`/register_yubikey`, {
            serial: values.serial,
            otp: values.otp1.slice(0, 12),
            operator_email: (localStorage.getItem("userEmail") || "").trim(),
        }).then((response) => {
            if (response.data.success) {
                toast.success("YubiKey registered successfully!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "light",
                });
            } else {
                toast.error(response.data.msg || "Failed to register YubiKey", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "light",
                });
            }
        }).catch((error) => {
            toast.error("An error occurred while registering YubiKey", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
            });
        });
        resetForm();
    };

    return (
        <div className="dashboard">
            <UserProfileHeader isAdmin={true} />
            <div className="register-yubikey-container">
                <h1 className="register-yubikey-title">Register VELOX Cloud Key</h1>

                <div className="register-yubikey-card">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {() => (
                            <Form className="register-yubikey-form">
                                <div className="register-yubikey-form-group">
                                    <Field
                                        name="serial"
                                        type="text"
                                        className="register-yubikey-input"
                                        placeholder="VELOX Cloud Key Serial Number"
                                    />
                                    <ErrorMessage component="div" name="serial" className="register-yubikey-error" />
                                </div>

                                <div className="register-yubikey-form-group">
                                    <Field
                                        name="otp1"
                                        type="text"
                                        className="register-yubikey-input"
                                        placeholder="VELOX Cloud Key OTP 1"
                                    />
                                    <ErrorMessage component="div" name="otp1" className="register-yubikey-error" />
                                </div>

                                <div className="register-yubikey-form-group">
                                    <Field
                                        name="otp2"
                                        type="text"
                                        className="register-yubikey-input"
                                        placeholder="VELOX Cloud Key OTP 2"
                                    />
                                    <ErrorMessage component="div" name="otp2" className="register-yubikey-error" />
                                </div>

                                <button type="submit" className="register-yubikey-submit">
                                    Registr VELOX Cloud Key
                                </button>
                            </Form>
                        )}
                    </Formik>
                </div>
                <ToastContainer />
            </div>
        </div>
    );
};

export default RegisterYubiKey;
